module.exports = __webpack_public_path__ + "img/ws_2.4eb1c20d.png";